import type { MediaItem } from '../../components/MediaCarousel/MediaCarousel'

import fruitSellerChased from 'url:./2026.08.04-fruit-seller-chased.mp4'
import bridgeAttack from 'url:./2026.08.02-teenager-killed-under-bridge.mp4'
import busAttack from 'url:./2026.08.20-human-safari-bus-attack.jpeg'
import fpvDrone from 'url:./Andrushenko, FPV drone.jpg'
import firefighter from 'url:./Andrushenko, human safari.jpg'
import burntCar from 'url:./Ivan Antypenko, Kherson burnt out car.jpg'
import antiDroneNets from 'url:./Ivan Antypenko, Kherson street covered by nets against human safari drones.jpg'

import fruitSellerChasedThumb from 'url:./thumbs/2026.08.04-fruit-seller-chased.webp'
import bridgeAttackThumb from 'url:./thumbs/2026.08.02-teenager-killed-under-bridge.webp'
import busAttackThumb from 'url:./thumbs/2026.08.20-human-safari-bus-attack.webp'
import fpvDroneThumb from 'url:./thumbs/Andrushenko, FPV drone.webp'
import firefighterThumb from 'url:./thumbs/Andrushenko, human safari.webp'
import burntCarThumb from 'url:./thumbs/Ivan Antypenko, Kherson burnt out car.webp'
import antiDroneNetsThumb from 'url:./thumbs/Ivan Antypenko, Kherson street covered by nets against human safari drones.webp'

/**
 * Photos and clips of the Human Safari, in the order the carousel shows them. `description` and
 * `credit` are i18n keys rather than literal text, so the caption follows the
 * selected language; `aspect` is the file's intrinsic ratio, so the modal can
 * reserve the right shape before the media loads.
 *
 * The carousel takes any such array — this one is just what the right bank
 * currently shows.
 */
export const khersonMedia: MediaItem[] = [
  {
    type: 'video',
    src: fruitSellerChased,
    thumb: fruitSellerChasedThumb,
    aspect: 1280 / 720,
    date: '2026.08.04',
    description: 'media.fruitSellerDescription',
    credit: 'media.khersonPoliceCredit',
    creditHref: 'https://t.me/khersonpolice',
  },
  {
    type: 'image',
    src: burntCar,
    thumb: burntCarThumb,
    aspect: 4942 / 3295,
    description: 'media.burntCarDescription',
    credit: 'media.antypenkoCredit',
  },
  {
    type: 'image',
    src: busAttack,
    thumb: busAttackThumb,
    aspect: 904 / 1205,
    date: '2026.08.20',
    description: 'media.busAttackDescription',
    credit: 'media.khersonPoliceCredit',
    creditHref: 'https://t.me/khersonpolice',
  },
  {
    type: 'video',
    src: bridgeAttack,
    thumb: bridgeAttackThumb,
    aspect: 576 / 576,
    date: '2026.08.02',
    description: 'media.bridgeAttackDescription',
    credit: 'media.telegramChannelCredit',
  },
  {
    type: 'image',
    src: fpvDrone,
    thumb: fpvDroneThumb,
    aspect: 2252 / 1501,
    description: 'media.fpvDroneDescription',
    credit: 'media.andrushenkoCredit',
  },
  {
    type: 'image',
    src: antiDroneNets,
    thumb: antiDroneNetsThumb,
    aspect: 4209 / 2806,
    description: 'media.antiDroneNetsDescription',
    credit: 'media.antypenkoCredit',
  },
  {
    type: 'image',
    src: firefighter,
    thumb: firefighterThumb,
    aspect: 2814 / 1876,
    description: 'media.firefighterDescription',
    credit: 'media.andrushenkoCredit',
  },
]
